import {
	analyticsActionCauseList,
	Component,
	IAnalyticsNoMeta,
	IComponentBindings,
	Initialization,
	InitializationEvents,
	IOmniboxOptions
	} from "coveo-search-ui";
import { RecentSearches } from "./RecentSearches";
import { SearchAssistButton } from "./SearchAssistButton";
import { SearchAssistFilters } from "./SearchAssistFilters";
import { SearchHelper } from "./../models/SearchHelper";
import * as $ from "jquery";

export class SearchAssist extends Component {
	static ID = "SearchAssist";
	private $megamenu: JQuery;
	private searchButton: SearchAssistButton;
	private searchHelper: SearchHelper = SearchHelper.Instance;
	private searchbox: Coveo.Omnibox;

	private get suggestionUrl() {
		return this.searchbox.magicBox.getWordCompletion()
			? $(".coveo-omnibox-selected a", this.searchbox.magicBox.element).attr("href")
			: null;
	}

	private get searchQuery() {
		return $("input", this.searchbox.element).val();
	}

	constructor(public element: HTMLElement, options: IOmniboxOptions, bindings: IComponentBindings) {
		super(element, SearchAssist.ID, bindings);
		this.searchbox = new Coveo.Omnibox(this.element, options, bindings);
		this.bind.onRootElement(InitializationEvents.afterComponentsInitialization, () => this.afterComponentsInitialization());
	}

	public hideMenu() {
		this.$megamenu.removeClass("active");
	}

	public showMenu() {
		this.$megamenu.addClass("active");
	}

	public performSearch(e?: any) {
		var url;

		if (e && e.preventDefault) {
			e.preventDefault();
		}

		if (!this.searchButton.isEnabled) {
			return false;
		}

		this.searchButton.disable();

		// checks if something in the omnibox is selected
		var selected = this.suggestionUrl;
		if (selected) {
			this.usageAnalytics.logSearchEvent<IAnalyticsNoMeta>(analyticsActionCauseList.searchFromLink, {});
			url = selected;
		} else {
			this.usageAnalytics.logSearchEvent<IAnalyticsNoMeta>(analyticsActionCauseList.searchboxSubmit, {});
			url = this.searchButton.href;

			var forceReload = window.location.href.indexOf(url) > -1,
				filters = this.getFilters(),
				selectedFilters = filters? filters.getUriEncodedSelectedValues().join(",") : "",
				query = this.searchQuery;

			if (selectedFilters.length) {
				url += `${filters.urlHashId}=[${selectedFilters}]`;
				if (query.length) {
					url += "&";
				}
			}

			if (query.length) {
				url += `q=${encodeURIComponent(query)}`;
				this.searchHelper.addSearchTerm(query);
			}

			if (url === this.searchButton.href) {
				return;
			}
		}

		this.searchButton.enable();

		window.location.href = url;

		// if we are on the site search page, then "window.location.href = url" will not
		// trigger a reload since only the hash part of the url is changing. so we manually
		// close the search assist menu and reload
		if (forceReload) {
			this.hideMenu();
			window.location.reload();
		}

		return false;
	}

	private afterComponentsInitialization() {
		this.$megamenu = $(".search-mega");
		var $searchbox = $(this.element), $input =  $searchbox.find("input");

		if ( $input.length) {
			$input.on("focus", () => this.showMenu())
				.on("keydown", (e) => {
					if (e.which === 13) {
						this.performSearch();
					}
				});
			this.$megamenu.find(".close").on("click", () => this.hideMenu());
		}

		this.searchButton = this.getSearchButton();
		$(this.searchButton.element).on('click', this.performSearch.bind(this));
	}

	private getSearchButton(): SearchAssistButton {
		var facetElement = (Coveo as any).$(".Coveo" + SearchAssistButton.ID);
		return facetElement.coveo(SearchAssistButton) as SearchAssistButton;
	}

	private getFilters(): SearchAssistFilters {
		var facetElement = (Coveo as any).$(".Coveo" + SearchAssistFilters.ID);
		return facetElement.coveo(SearchAssistFilters) as SearchAssistFilters;
	}
}

Initialization.registerAutoCreateComponent(SearchAssist);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SearchAssist.ts